/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Search: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="search" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M786.3066666666666 396.6666666666668A453.3333333333333 453.3333333333333 0 1 0 913.41 501.2733333333334A170 170 0 0 0 979.9366666666666 460.1900000000001L1230.0633333333333 210.0633333333335L1149.9366666666665 129.9366666666667L899.81 380.0633333333334C873.1766666666666 406.6966666666667 819.0033333333332 409.36 786.3066666666666 396.6666666666668zM906.6666666666666 793.3333333333334A340.0000000000001 340.0000000000001 0 1 0 226.6666666666667 793.3333333333334A340.0000000000001 340.0000000000001 0 0 0 906.6666666666666 793.3333333333334zM793.3333333333333 793.3333333333334A226.6666666666667 226.6666666666667 0 0 1 566.6666666666666 1020V908.1966666666668A114.92 114.92 0 0 0 681.53 793.3333333333334H793.3333333333333z" : "M629.0453333333334 317.3333333333333A362.6666666666667 362.6666666666667 0 1 0 730.7280000000001 401.0186666666666A136 136 0 0 0 783.9493333333334 368.152L984.0506666666668 168.0506666666667L919.9493333333334 103.9493333333332L719.8480000000001 304.0506666666667C698.5413333333333 325.3573333333333 655.2026666666667 327.488 629.0453333333334 317.3333333333333zM725.3333333333334 634.6666666666666A272 272 0 1 0 181.3333333333334 634.6666666666666A272 272 0 0 0 725.3333333333334 634.6666666666666zM634.6666666666667 634.6666666666666A181.3333333333334 181.3333333333334 0 0 1 453.3333333333334 816V726.5573333333333A91.936 91.936 0 0 0 545.224 634.6666666666666H634.6666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Search.displayName = `Blueprint5.Icon.Search`;
export default Search;
